import { combineReducers } from 'redux';

import notification from '~/state/slices/notificationSlice';
import user from '~/state/slices/userSlice';
import actingAs from '~/state/slices/actingAsSlice';
import { toolboxApi } from '~/modules/query/base';
import { aiApi } from '~/modules/query/ai';

const reducers = combineReducers({
  notification,
  user,
  actingAs,
  [toolboxApi.reducerPath]: toolboxApi.reducer,
  [aiApi.reducerPath]: aiApi.reducer,
});

export type RootState = ReturnType<typeof reducers>;

export default reducers;
